import React from "react";
import PropTypes from "prop-types";

// styles
import { TextAreaStyled } from "./styles.js";

export const TextArea = ({
    value,
    onChange,
    inputRef,
    controlId,
    ariaLabel,
    placeholder,
    onBlur,
    errorMessage,
    hideLabel = false,
    height = 128,
    ...rest
}) => {
    return (
        <TextAreaStyled
            ref={inputRef}
            id={controlId}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            ariaLabel={ariaLabel}
            placeholder={placeholder}
            height={height}
            {...rest}
        />
    );
};

export default TextArea;

// prop-types
TextArea.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    inputRef: PropTypes.any,
    controlId: PropTypes.string,
    ariaLabel: PropTypes.string,
    placeholder: PropTypes.string,
    errorMessage: PropTypes.string,
    hideLabel: PropTypes.bool,
    height: PropTypes.number,
    inputProps: PropTypes.object
};
